import React from "react";
import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";
import { Outlet } from "react-router";

function HomeLayout() {
  return (
    <>
      <Header />
      <div>
        <Outlet />
      </div>
      <div className="relative">
        <Footer />
      </div>
    </>
  );
}

export default HomeLayout;
